import { AcpFormTypes, ViewPatientInfoErrorCode } from "common/constant/v2/acp";
import { HTTP_VERBS } from "../../enums";

export const httpVerb = HTTP_VERBS.GET;
export const url = "/api/v1/acp/patient";

export class Response {
	NRIC!: string;
	PublishedFormIndcator!: boolean;
	RequestID!: string;
	FormType!: AcpFormTypes;
	ACPForm!: string;
	PublishedDate!: string;
	Status!: "Success" | "Failed";
	Message!: string;
	Institution!: string;
	// to be confirm what is this
	DraftFormIndicator!: boolean;
	errorCode!: ViewPatientInfoErrorCode;
	isAcpRegisteredOnLegacy!: boolean | null;
}
